import React, { useSyncExternalStore } from 'react';
import {
  getFirestoreRuntimeFailure,
  subscribeFirestoreRuntimeFailure,
} from '../functions/firestoreRuntimeRecovery';
import './FirestoreRecoveryNotice.css';

export default function FirestoreRecoveryNotice() {
  const failure = useSyncExternalStore(
    subscribeFirestoreRuntimeFailure,
    getFirestoreRuntimeFailure,
    getFirestoreRuntimeFailure,
  );
  if (!failure) return null;
  return (
    <aside
      className="ts-firestore-recovery"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      aria-labelledby="ts-firestore-recovery-title"
    >
      <div className="ts-firestore-recovery__text">
        <h2 id="ts-firestore-recovery-title">Refresh TutorSpace to reconnect</h2>
        <p>Live updates and saves may be unavailable. Copy any unfinished text before refreshing.</p>
      </div>
      <button type="button" onClick={() => window.location.reload()}>
        Refresh TutorSpace
      </button>
    </aside>
  );
}
